import { Tag, TagProps } from '@chakra-ui/react';
import { Icon, IconName } from '../../medias';

export function ActiveTag({
  tagLabel,
  children,
  ...rest
}: TagProps & { tagLabel?: string }): JSX.Element {
  return (
    <Tag colorScheme="success" {...rest}>
      <Icon h="16px" mr="5px" w="16px" name={IconName.Check} />
      {(children || tagLabel) ?? 'Active'}
    </Tag>
  );
}
